import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function useProgramsText({ selectedPrograms = [], selectedSeries = [], selectedUsers = [], selectedCoaches = [] }) {
  const { t } = useTranslation()

  return useMemo(() => {
    const totalRecipients =
      selectedPrograms.reduce((acc, p) => acc + (p.students?.length || 0), 0) +
      selectedSeries.reduce((acc, s) => acc + (s.students?.length || 0), 0) +
      (selectedUsers.length || 0) +
      (selectedCoaches.length || 0)

    if ((selectedPrograms.length > 0 || selectedSeries.length > 0) && selectedUsers.length === 0 && selectedCoaches.length === 0) {
      const names = [...selectedPrograms.map(p => p.name), ...selectedSeries.map(s => s.title)]
      if (names.length === 1) {
        return t('dashboard.coach.useProgramsText.postedToName', { name: names[0] })
      } else {
        return t('dashboard.coach.useProgramsText.postedToNameAndOthers', { name: names[0], count: names.length - 1 })
      }
    }

    if (totalRecipients > 0) {
      return t('dashboard.coach.useProgramsText.postedToMembers', { count: totalRecipients })
    }

    return t('dashboard.coach.useProgramsText.addMembers')
  }, [t, selectedPrograms, selectedSeries, selectedUsers, selectedCoaches])
}
